import { render, staticRenderFns } from "./TransferTk.vue?vue&type=template&id=318fbb20&scoped=true"
import script from "./TransferTk.vue?vue&type=script&lang=js"
export * from "./TransferTk.vue?vue&type=script&lang=js"
import style0 from "./TransferTk.vue?vue&type=style&index=0&id=318fbb20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "318fbb20",
  null
  
)

export default component.exports